<h2 mat-dialog-title>
	<mat-icon style="margin-right: 8px">domain_add</mat-icon>{{ 'institution.create.title' | transloco }}
</h2>
<mat-dialog-content>
	<form class="dialog-window" [formGroup]="form">
		<div>
			<p lvrPadding [padVertical]="8">{{ 'institution.create.hint1' | transloco }}</p>
			<mat-form-field lvrInput [class]="showWarning() ? 'lvr-warning' : ''">
				<input
					matInput
					formControlName="institutionName"
					[placeholder]="'institution.create.placeholder' | transloco"
					[matAutocomplete]="auto"
				/>
				<mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption [displayWith]="displayName">
					@if (!form.get('institutionName')?.value) {
						<mat-option disabled>
							{{ 'institution.create.no_input' | transloco }}
						</mat-option>
					} @else if (suggestions().length <= 0) {
						<mat-option disabled>
							{{ 'institution.create.no_suggestion' | transloco }}
						</mat-option>
					} @else {
						@for (item of suggestions(); track item.type + '-' + item.id) {
							<mat-option [value]="item">
								<div>
									{{ item.name }}
									<span class="text-sm">
										{{
											(item.type === 'institution' ? 'client.career.main_branch' : 'personType.institution_branch')
												| transloco
										}}
									</span>
								</div>

								@if (item.addressText) {
									<div style="font-size: 0.8rem; opacity: 0.7">
										{{ item.addressText }}
									</div>
								}
							</mat-option>
						}
					}
				</mat-autocomplete>
				@if (showWarning()) {
					<mat-hint class="lvr-warning">{{ 'institution.create.suggestion_found' | transloco }}</mat-hint>
				}
			</mat-form-field>
		</div>
		<mat-dialog-actions class="actions-row">
			<lvr-button
				variant="secondary"
				[label]="'base.button.cancel' | transloco"
				[type]="'button'"
				(clicked)="selfRef.close()"
				icon="disabled_by_default"
			>
			</lvr-button>
			<lvr-button
				variant="primary"
				[label]="btnText() | transloco"
				[type]="'button'"
				[disabled]="form.invalid"
				(clicked)="done()"
				icon="add"
			>
			</lvr-button>
		</mat-dialog-actions>
	</form>
</mat-dialog-content>
